<template>
  <h1 
   class="text-2xl font-semibold mb-10"
  >
    Log in to {{ partnerName }} to access all app features
  </h1>
      
      <!-- Header / Logo -->
      <div class="flex justify-center mb-4">
        <!-- Replace with actual logo -->
        <div class="flex justify-start w-full gap-x-6">
          <div class="flex items-center gap-x-2">
            <p class="justify-center text-sm text-gray-500 font-small">Powered by</p>
            <NuxtImg src="https://newdelhi.ad-tech.com/wp-content/uploads/2021/11/ONDC_logo.png" alt="ONDC Logo" title="ONDC Logo" class="h-6 w-auto" />
          </div>
          <div class="flex items-center gap-x-2">
            <p class="text-center text-sm text-gray-500 font-small">Built by</p>
            <NuxtImg src="https://cdn.prod.website-files.com/676e392bc4060ff4a69a8564/6789de90c979207262a0879b_677a5201115e12eff6bf50a9_nStore%20001%202%20(1).png" alt="nStore Logo" title="nStore Logo" class="h-3 w-auto" />
          </div>
        </div>
      </div>

      <!-- Conditional OTP / Mobile Form -->
      <div v-if="isOTPSent" class="flex flex-col gap-4">
        <!-- OTP Info -->
        <div class="text-center flex flex-col gap-2">
          <h5 class="text-lg font-extrabold text-gray-900">Verify with OTP</h5>
          <p class="text-gray-600 text-sm">
            Enter the one time password sent to your registered mobile number. {{ masked }}
            <button @click="reset" class="text-primary-600 font-semibold ml-1">Change</button>
          </p>
        </div>

        <!-- OTP Form -->
        <div class="bg-gray-50 rounded-xl p-5 flex flex-col gap-6 ">
          <UForm :state="state" class="space-y-6 w-full py-2">
            <div class="flex justify-center gap-2">
              <input
                v-for="(digit, idx) in 6"
                :key="idx"
                type="text"
                data-max="1"
                inputmode="numeric"
                pattern="[0-9]*"
                class="w-10 h-12 text-center border rounded-lg text-xl focus:border-primary focus:ring-primary outline-none"
                :value="otp[idx] || ''"
                @input="onOtpInput($event, idx)"
                @keydown="onOtpKeydown($event, idx)"
                @paste="onOtpPaste($event)"
                autocomplete="one-time-code"
                :ref="el => setOtpInputRef(el, idx)"
              />
            </div>
            <!-- Error -->
            <p v-if="error.length" class="flex items-center text-red-600 text-sm gap-2">
              <V3ImageComponent src="icons/danger.png" class="h-3 w-3" />
              {{ error }}
            </p>

            <!-- Submit Button -->
            <UButton
              type="button"
              label="Submit"
              size="lg"
              block
              :loading="isChecking"
              class="text-white bg-primary-500"
              @click="verifyOTP"
            />

            <!-- Resend Info -->
            <div class="text-center text-sm text-gray-500">
              <p v-if="!resendDisabled">
                OTP sent. Didn't receive?
                <button
                  type="button"
                  @click="resendOTP"
                  :disabled="resendDisabled"
                  class="text-primary-600 font-semibold disabled:text-gray-400 disabled:cursor-not-allowed ml-1"
                >
                  Resend OTP
                </button>
              </p>
              <p v-if="resendDisabled">Resend OTP available in {{ timer }} seconds</p>
            </div>
          </UForm>
        </div>
      </div>

      <div v-else class="flex flex-col gap-4">

        <!-- Mobile Form -->
            <UForm :schema="schema" :state="state" class="space-y-2 w-full" @submit="onSubmit">
            <div class="w-full">
                <label 
                class="block text-sm font-medium text-gray-800 mb-2" 
                > Name*
                </label>
              <div class="relative">
                <input
                  v-model="state.name"
                  size="lg"
                  placeholder="Enter your full name"
                  @blur="validateName"
                  @input="handleNameInput"
                 class="w-full mb-4 pl-4 text-sm h-[44px] rounded-lg border-[2px] p-3 focus:border-primary focus:ring-primary outline-none"/>
                <p class="text-xs text-gray-500">Please enter your full name with letters only; 3-40 chars required</p>
          <div class="min-h-[18px]">
              <p v-if="nameError" class="text-red-600 text-sm">{{ nameError }}</p>
            </div>            
            </div>
            </div>
          <div class="w-full">
  <label 
    class="block text-sm font-medium text-gray-800 mb-2" 
    > Mobile Number*
  </label>
  <div class="relative">
  <div
  class="absolute inset-y-0 left-4 flex items-center gap-2 pointer-events-none z-20"
>
  <img src="https://flagcdn.com/in.svg" alt="India Flag" title="India Flag" class="h-4 w-6 rounded-sm border" />
  <span class="font-semibold text-gray-700 text-sm">+91</span>
</div>

    <input
      v-model="state.mobile"
      inputmode="numeric"
      pattern="[0-9]*"
      @blur="validateMobile"
      @input="handleMobileInput"
      placeholder="Enter 10-digit mobile number"
      class="pl-20 text-sm h-[44px] w-full rounded-lg border-[2px] p-3 focus:border-primary focus:ring-primary focus:outline-none"
    />
  </div>
      <p v-if="mobileError" class="text-red-600 text-sm mt-4 ">{{ mobileError }}</p>

  <p class="text-xs text-gray-500 mt-4">An OTP will be sent to this number for verification</p>
</div>

            <!-- Error -->
            <p v-if="error.length" class="flex items-center text-red-600 text-sm gap-2">
              <V3ImageComponent src="icons/danger.png" class="h-3 w-3" />
              {{ error }}
            </p>

            <!-- Get OTP Button -->
            <UButton
              type="submit"
              label="Get OTP"
              size="lg"
              block
              :loading="isLoading"
              :disabled="isButtonDisabled"
              class="text-white h-[44px] rounded-lg w-full focus:outline-none"
              :class="[isButtonDisabled ? 'bg-primary-100' : 'bg-primary-500']"
            />
            <!-- Terms & Policy -->
            <div class="text-center text-sm text-gray-500" v-if="runtimeConfig?.public?.partnerCode?.toLowerCase() === 'mall4all'">
              <p>By proceeding, you agree to the</p>
              <p class="flex justify-center gap-1 mt-4">
                <a href="/about/terms" class="text-primary-600 font-semibold mb-4">Terms & Conditions</a>
                <span>and</span>
                <a href="/about/privacy-policy" class="text-primary-600 font-semibold">Privacy Policy</a>
              </p>
            </div>
          </UForm>
        </div>
    
</template>

<script setup lang="ts">
import * as v from 'valibot';
import type { FormSubmitEvent } from '#ui/types';
const validMobileRegex = /^[6-9]\d{9}$/;
import { useLoginBanner } from '@/composables/useLoginBanner';
import { _left } from '#tailwind-config/theme/backgroundPosition';
import { getPostAuthRedirect, clearPostAuthRedirect } from '~/utility/authRedirect'; // adjust path if needed
import { useAnalytics, useAnalyticsEvents } from '#imports';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter , EventStatus} from '~/google_analytics/events.enum';

const { showWelcomeBanner } = useLoginBanner();
const addressStore = useUserAddressStore();
const resendDisabled = ref(false);
const route = useRoute();
const timer = ref(30);
const resendCount = ref(0);
const maxResendAttempts = 2;
const auth = useAuth();
const { gtag } = useGtag();
const analyticsEvents = useAnalyticsEvents();
const schema = v.object({
  // name: v.pipe(v.string(), v.minLength(1, 'The field cannot be left blank')),
  // mobile: v.pipe(
  //   v.any(),
  //   v.transform((input) => input.toString()),
  //   v.minLength(10, 'Provide 10-digit mobile number'),
  //   v.maxLength(10, 'Provide 10-digit mobile number')
  // )
  name: v.optional(v.any()),
  mobile: v.optional(v.any())
});
type Schema = v.InferOutput<typeof schema>;

const state = reactive({
  name: '',
  mobile: ''
});

const emits = defineEmits(['success', 'close']);
const nameTouched = ref(false);

function handleNameInput(event: any) {
  let value = event.target.value.replace(/[^a-zA-Z\s]/g, "");

  if (value.length > 40) {
    value = value.slice(0, 40);
  }
  state.name = value;
  event.target.value = value;
  const name = state.name.trim();
  if (!name.length) {
    nameTouched.value = false;
    nameError.value = "";
    return;
  }
  if (!nameTouched.value) {
    nameError.value = "";
    return;
  }
  if (name.length < 3) {
    nameError.value = "Full name should contain at least 3 characters";
  } else {
    nameError.value = "";
  }
};
const validateName = () => {
  nameTouched.value = true;
  const name = state.name.trim();

  if (!name.length) {
    nameError.value = "";
    return;
  }
  if (name.length < 3) {
    nameError.value = "Full name should contain at least 3 characters";
  } else if (name.length > 40) {
    nameError.value = "Full name cannot exceed 40 characters";
  } else {
    nameError.value = "";
  }
};
const isButtonDisabled = computed(() => {
  const isNameValid = /^[a-zA-Z\s]{3,40}$/.test(state?.name?.trim());
  const isMobileValid = state?.mobile?.toString().trim().length === 10;
  return !(isNameValid && isMobileValid);
});
declare global {
  interface Window {
    BflAutoReadOTP: (otp: string) => void;
  }
}
const BflAutoReadOTP = (receivedOtp: any) => {
  if (!receivedOtp || receivedOtp.length !== 6) return;
  otp.value = receivedOtp; 
  for (let i = 0; i < 6; i++) {
    if (otpInputs.value[i]) {
      otpInputs.value[i]!.value = receivedOtp[i];
    }
  }
 
  otpInputs.value[5]?.focus(); 
  setTimeout(() => {
    verifyOTP();
  }, 100);
};

window.BflAutoReadOTP = BflAutoReadOTP;
 
 
 
function handleMobileInput(event: any) {
  let value = event.target.value.replace(/\D/g, "").slice(0, 10);

  state.mobile = value;
  event.target.value = value;

  mobileError.value = "";
}

const validateMobile = () => {
  const mobile = state.mobile?.trim();

  if (!mobile.length) {
    mobileError.value = "";
    return;
  }

  if (mobile.length !== 10) {
    mobileError.value = "Mobile number must be 10 digits";
  } else {
    mobileError.value = "";
  }
};
const isNewUser = async (phone: any) => {
  try {
    const response: any = await useAPIHandler('post', '/auth/userexist', {
      body: { partner: runtimeConfig.public.partnerCode, phone }
    });
    localStorage.setItem('userExists', response.data.Exist);
    return response.data.Exist
  } catch (err) {
    return false;
  }
};
const handleOtpInput = (event: KeyboardEvent) => {
  if (otp.value) {
    const value = otp.value.toString()
    if (value.length > 5 && event.key !== "Backspace") {
      event.preventDefault();
      return;
    }
  }
};
// const sendOTP = async (name: string, phone: string) => {
//   error.value = '';
//   try {
//     const { error } = await useAPIHandler('post', '/auth/otp', {
//       body: { partner: runtimeConfig.public.partnerCode, name, phone }
//     });
//     if (error) {
//       throw new Error();
//     }  
//     isOTPSent.value = true;
//   } catch (err) {
//     error.value = 'Failed to send OTP. Please try after sometime.';
//   } finally {
//     isLoading.value = false;
//   }
// };

const verifyOTP = async () => {
  error.value = '';

  if (otp.value) {
    const value = otp.value.toString();
    if (value.length !== 6) {
      error.value = 'Please provide 6 digits OTP';
      return;
    }
  } else {
    error.value = 'Otp field cannot be empty';
    return;
  }
  GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "submit_otp",
    [EventParameter.STATUS]: [EventStatus.IN_PROGRESS],
    [EventParameter.ERROR_MESSAGE]: 'none',
  })

  isChecking.value = true;
  try {
    const apiResult: any = await useAPIHandler('post', '/auth/otp/verify', {
      body: { partner: runtimeConfig.public.partnerCode, phone: state?.mobile, otp: otp.value }
    });
    const { access_token, user, toast_message, new_user } = apiResult.data

    await auth.setAccessToken(access_token)
    user.id = user?._id
    await auth.setUser(user);
    showWelcomeBanner(
      { first_name: user?.first_name, phone: state?.mobile },
      Boolean(new_user),
      3000,
      {
        toast_variant: new_user ? 'first_time' : 'repeat',
      }
    )

    await addressStore.fetchAddresses();

    GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "login_success",
    [EventParameter.STATUS]: [EventStatus.SUCCESS],
    [EventParameter.ERROR_MESSAGE]: 'none',
  });
    // useAnalytics(analyticsEvents.CTA_EVENT, {
    //   action: 'click',
    //   cta_name: 'submit otp',
    // });
    if (import.meta.client && typeof (window as any).dht === 'function') {
      (window as any).dht('submit_otp');
    }
    
    const redirect = getPostAuthRedirect();
    if (redirect) {
      clearPostAuthRedirect();
      emits('close');
      if ( redirect.redirectionType === 'external' || redirect.path.startsWith('sso:') || redirect.path.startsWith('http://') || redirect.path.startsWith('https://')) {
        await useExternalLinkHandler(redirect.path, { openInNewTab: true });
        return;
      }
      const finalUrl =  redirect.query? `${redirect.path}?${redirect.query}` : redirect.path;
      useSSOAuth(finalUrl);
      // await navigateTo({ path: redirect.path, query: redirect.query || {} });
      return;
    }

    const postAuthRedirect = localStorage.getItem("postAuthRedirect");
    if (postAuthRedirect) {
    const { path, query } = JSON.parse(postAuthRedirect);
    localStorage.removeItem("postAuthRedirect");
    emits('success');
    const finalUrl =  query? `${path}?${query}` : path;
    useSSOAuth(finalUrl);
    // await navigateTo({ path, query: query || {} });
    return;
  }

    const fromCartPage = localStorage.getItem('FromCartPage');
    if (fromCartPage === 'true') {
      useSSOAuth(route.fullPath);
      setTimeout(() => emits('success'), 100);
      emits('close');
      localStorage.removeItem("FromCartPage");
      return;
    }
    // window.location.reload();
    useSSOAuth(route.fullPath);
    setTimeout(() => emits('success'), 100);
    // if(new_user) {
    //   await navigateTo({
    //     path: '/account/profile',
    //     query: { redirect: route.fullPath }
    //   });
    // } else {
    //   await navigateTo('/menu');
    // }
    // Always close the modal after successful OTP verification
    emits('close');
    
  } catch (err) {
     GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]:"login failed",
    [EventParameter.STATUS]: [EventStatus.FAILED],
    [EventParameter.ERROR_MESSAGE]: err instanceof Error ? err.message : 'Invalid OTP',
  })

    console.log("error", err);
    error.value = 'Invalid OTP';
  } finally {
    isChecking.value = false;
  }
};

const reset = () => {
  otp.value = '';
  isOTPSent.value = false;
  error.value = '';
};

async function onSubmit(event: FormSubmitEvent<Schema>) {
  validateName();
  validateMobile();

  if (nameError.value || mobileError.value) {
    return; // stop submitting if any error exists
  }

  isLoading.value = true;
  GoogleAnalytics.loginEvent({
  [EventParameter.ACTION]: "get_otp",
  [EventParameter.STATUS]: [EventStatus.IN_PROGRESS],
  [EventParameter.ERROR_MESSAGE]: 'none',
});
  const { name, mobile } = event.data;
  await sendOTP(name, mobile.toString());
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'get_otp',
  });
  useAnalytics(analyticsEvents.CTA_EVENT, {
    action: 'click',
    cta_name: 'get otp',
  });
}

const runtimeConfig = useRuntimeConfig();

const isLoading = ref(false);
const isOTPSent = ref(false);
const isChecking = ref(false);
const error = ref('');
const nameError = ref('');
const mobileError = ref('');
const partnerName = runtimeConfig.public.partnerName;
const otp = ref<string>('');

const masked = computed(() => `+91 xxxxxxxx${state?.mobile.toString().substring(8, 10)}`);


const startTimer = () => {
  resendDisabled.value = true;
  timer.value = 30;
  const interval = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    } else {
      resendDisabled.value = false;
      clearInterval(interval);
    }
  }, 1000);
};

const resendOTP = async () => {
  if (resendDisabled.value || resendCount.value >= maxResendAttempts) {
    error.value = resendCount.value >= maxResendAttempts
      ? 'Maximum resend attempts reached. Please try again later.'
      : '';
    return;
  }

  error.value = '';
  isLoading.value = true;

  GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "resend_otp",
    [EventParameter.STATUS]: [EventStatus.IN_PROGRESS],
    [EventParameter.ERROR_MESSAGE]: 'none',
  });

  try {
    await sendOTP(state.name, state.mobile.toString());
    GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "resend_otp_success",
    [EventParameter.STATUS]: [EventStatus.SUCCESS],
    [EventParameter.ERROR_MESSAGE]: 'none',
  });
    resendCount.value++; // Increment the counter after a successful attempt
    startTimer();
  } catch (err) {
    error.value = 'Failed to resend OTP. Please try again later.';
    GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "resend_otp_failed",
    [EventParameter.STATUS]: [EventStatus.FAILED],
    [EventParameter.ERROR_MESSAGE]: err instanceof Error ? err.message : 'Failed to resend OTP',
  });
  } finally {
    isLoading.value = false;
  }
};

// Call startTimer when OTP is sent for the first time
const sendOTP = async (name: string, phone: string) => {
  error.value = '';
  try {
    await isNewUser(phone);
    const { error } = await useAPIHandler('post', '/auth/otp', {
      body: { partner: runtimeConfig.public.partnerCode, name, phone }
    });
    if (error) {
      throw new Error();
    }
    isOTPSent.value = true;
    startTimer(); // Start the timer on OTP send
  } catch (err) {
    error.value = 'Failed to send OTP. Please try after sometime.';
    GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "get_otp",
    [EventParameter.STATUS]: [EventStatus.FAILED],
    [EventParameter.ERROR_MESSAGE]: err instanceof Error ? err.message : 'failed_to_send_otp',
  });
  } finally {
    isLoading.value = false;
  }
};
// --- OTP Input Focus Logic ---
const otpInputs = ref<(HTMLInputElement | null)[]>([]);

function setOtpInputRef(el: HTMLInputElement | null, idx: number) {
  if (el) otpInputs.value[idx] = el;
}
 
function onOtpInput(event, idx) {
  const input = event.target;
  let val = input.value.replace(/\D/g, '');
 
  // Android tap-to-paste: receives full OTP here
  if (val.length === 6) {
    return fillOtpFromPaste(val);
  }
 
  // Normal typing (keep only first digit)
  if (val.length > 1) {
    val = val[0];
  }
 
  input.value = val;
  otp.value = otp.value.substring(0, idx) + val + otp.value.substring(idx + 1);
 
  if (val && idx < 5) otpInputs.value[idx + 1]?.focus();
}
 
 
function onOtpKeydown(event: KeyboardEvent, idx: number) {
  const input = event.target as HTMLInputElement;
  if (event.key === 'Enter') {
    event.preventDefault();
    event.stopPropagation();
    verifyOTP();
    return;
  }
  if (event.key === 'Backspace') {
    if (!input.value && idx > 0) {
      otpInputs.value[idx - 1]?.focus();
    }
    return;
  }
  if (/^[0-9]$/.test(event.key) && input.value && idx < 5) {
    setTimeout(() => {
      otpInputs.value[idx + 1]?.focus();
    }, 0);
  }
}
watch(isOTPSent, (val) => {
  if (val) {
    nextTick(() => {
      const first = otpInputs.value[0];
      if (first) {
        first.focus();
        first.setAttribute('inputmode', 'numeric');
      }
    });
  }
});
function onOtpPaste(event: ClipboardEvent) {
  event.preventDefault();
  const paste = event.clipboardData?.getData('text') || '';
  if (!/^[0-9]{6}$/.test(paste)) return;
  otp.value = paste;
  for (let i = 0; i < 6; i++) {
    if (otpInputs.value[i]) {
      otpInputs.value[i]!.value = paste[i] || '';
    }
  }
  otpInputs.value[5]?.focus();
}
onMounted(() => {
  GoogleAnalytics.loginEvent({
    [EventParameter.ACTION]: "login_pop_up",
    [EventParameter.STATUS]: [EventStatus.IN_PROGRESS],
    [EventParameter.ERROR_MESSAGE]: 'none',
  })
  useAnalytics(analyticsEvents.COMPOUND_VIEWED, {
    page_name: 'login_component',
  });
  const firstInput = otpInputs.value[0];
 
  if (!firstInput) return;
 
  let lastValue = "";
 
  const interval = setInterval(() => {
    if (!otpInputs.value[0]) return;
 
    const current = otpInputs.value[0]!.value;
 
    // Detect auto-paste from Android keyboard
    if (current.length === 6 && current !== lastValue) {
      fillOtpFromPaste(current);
    }
 
    lastValue = current;
  }, 50); // 50ms = smooth, zero lag
});
function fillOtpFromPaste(code: string) {
  otp.value = code;
 
  for (let i = 0; i < 6; i++) {
    if (otpInputs.value[i]) {
      otpInputs.value[i]!.value = code[i];
    }
  }
 
  otpInputs.value[5]?.focus();
}
 
</script>
